import Cookie from 'js-cookie'

function appIsLoading(state) {
  return state.global.isLoading
}

function appInitialized(state) {
  return state.global.appInitialized
}

function userAuthenticated(state) {
  return state.authentication.userIsAuthenticated
}

function authCookieName(state) {
  return state.authentication.cookieName
}

function authCookie(state) {
  return Cookie.get(state.authentication.cookieName)
}

function authenticationErrorMessage(state) {
  return state.authentication.errorMessage
}

function debug(state) {
  return state.global.environment.match(/dev/)
}

function str(state) {
  return (key) => {
    return key.split('.').reduce((value, arg) => {
      return !value ? null : value[arg] || null
    }, state.strings)
  }
}

function assetsPath(state) {
  return state.global.assetsPath
}

function mapPreviewImgUrl(state) {
  const params = {
    center: state.cube.latitude + ',' + state.cube.longitude,
    zoom: 15,
    size: '400x150',
    key: state.global.googleMapsApiKey,
  }

  const baseUrl = state.global.googleMapsStaticApiBaseUrl
  let getParameters = Object.entries(params)
    .map((param) => {
      return param[0] + '=' + param[1]
    })
    .join('&')

  const result = baseUrl + '?' + getParameters
  return result
}

function googleMapsJavascriptStatus(state) {
  return state.global.googleMapsJavascriptStatus
}

function mapsDefaultZoom(state) {
  return state.map.defaultZoom
}

function sellingPriceStepSize(state) {
  return state.settings.producerSettings.defaultSellingPriceStepSize
}

function minDefaultSellingPrice(state) {
  return state.settings.producerSettings.minDefaultSellingPrice
}

function maxDefaultSellingPrice(state) {
  return state.settings.producerSettings.maxDefaultSellingPrice
}

function userNameCookieName(state) {
  return state.authentication.userNameCookieName
}

function mapsSidebarNumCubesShown(state) {
  return state.map.sidebar.numCubesShown
}

function isFormSubmitting(state) {
  return (formId) => {
    const form = formId.split('.').reduce((value, key) => {
      return value && value[key] ? value[key] : false
    }, state.forms)
    return form.state === 'submitting'
  }
}

function formState(state) {
  return (formId) => {
    return state.forms[formId] ? state.forms[formId].state : false
  }
}

function isCubeReachable(state) {
  return state.currentReads.isCubeReachable
}

function appVersion(state) {
  return state.global.appVersion
}

function appName(state) {
  return state.strings.global.title
}

function backendApiVersion(state) {
  return state.global.backendApiVersion
}

function reemApiVersion(state) {
  return state.global.reemApiVersion
}

function cubeApiVersion(state) {
  return state.global.cubeApiVersion
}

function formMessage(state) {
  return (formId) => {
    return state.forms[formId] ? state.forms[formId].message : false
  }
}

function planName(state) {
  return state.cube.planName
}

function iotDeviceId(state) {
  return state.cube.iotDeviceId
}

function showInverterData(state) {
  return state.cube.showInverterData
}

function pushSubscription(state) {
  return state.global.pushSubscription
}

function pushNotificationsEnabled(state) {
  return state.cube.webPushValue > 0 && state.cube.notificationsValue > 0
}

function slideinVisible(state) {
  return (slidein = false) => {
    if (slidein === false) {
      // Return whether or not any slidein is visible.
      return Object.entries(state.global.slideins).reduce((value, row) => {
        if (row[1].visible) {
          return true
        }
        return value
      }, false)
    } else {
      return state.global.slideins[slidein].visible
    }
  }
}

function showNotificationsRequestPopup(state) {
  return !state.global.isLoading && state.cube.showNotificationsRequestPopup
}

function notifications(state) {
  return state.cube.notifications
}

function unreadNotifications(state) {
  return state.cube.notifications.filter((n) => {
    return n.unread === 1
  })
}

function mainRouteNames(state) {
  return state.global.mainRouteNames
}

async function getBrowserWebPushSubscription(state) {
  const swRegistration = state.global.serviceWorkerRegistration
  if (!swRegistration) {
    throw new Error('Serviceworker not registered yet.')
  }

  if (!('pushManager' in swRegistration)) {
    return false
  }
  return await swRegistration.pushManager.getSubscription()
}

function browserSupportsNotifications() {
  return 'Notification' in window
}

function hasNotificationsPermission() {
  if (!browserSupportsNotifications()) {
    return false
  }
  return Notification.permission === 'granted'
}

function serviceWorkerRegistered(state) {
  return !!state.global.serviceWorkerRegistration
}

function serviceWorkerRegistration(state) {
  return state.global.serviceWorkerRegistration
}

function notificationSound(state) {
  return state.cube.notificationSound
}

function numNotificationsForTypeGroup(state) {
  return (group, onlyUnread = true) => {
    let notifications = state.cube.notifications

    if (onlyUnread) {
      notifications = state.cube.notifications.filter((n) => {
        return n.unread === 1
      })
    }

    if (group === 'any') {
      return notifications.length
    }
    if (typeof state.notificationTypeGroups[group] === 'undefined') {
      return 0
    }
    const types = state.notificationTypeGroups[group]
    return notifications.filter((n) => {
      return types.indexOf(n.type_name) > -1
    }).length
  }
}

function unknownWebPushSubscriptionForSession(state) {
  return state.cube.webPushValue === 2
}

function contactData(state) {
  return state.global.contact
}

export default {
  // Utility.
  assetsPath,
  debug,
  str,

  // General.
  appVersion,
  appName,
  backendApiVersion,
  reemApiVersion,
  cubeApiVersion,
  appIsLoading,
  appInitialized,
  isCubeReachable,
  isFormSubmitting,
  formState,
  formMessage,
  planName,
  iotDeviceId,
  showInverterData,
  slideinVisible,
  mainRouteNames,
  contactData,

  // Notifications and web push
  getBrowserWebPushSubscription,
  notifications,
  unreadNotifications,
  showNotificationsRequestPopup,
  pushSubscription,
  pushNotificationsEnabled,
  hasNotificationsPermission,
  serviceWorkerRegistered,
  serviceWorkerRegistration,
  notificationSound,
  numNotificationsForTypeGroup,
  unknownWebPushSubscriptionForSession,
  browserSupportsNotifications,

  // Authentication.
  userAuthenticated,
  authCookie,
  userNameCookieName,
  authCookieName,
  authenticationErrorMessage,

  // Prices.
  sellingPriceStepSize,
  minDefaultSellingPrice,
  maxDefaultSellingPrice,

  // Maps.
  mapPreviewImgUrl,
  googleMapsJavascriptStatus,
  mapsDefaultZoom,
  mapsSidebarNumCubesShown,
}
